let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bhn0g")).then(() => parcelRequire('etC3C'));